// extracted by mini-css-extract-plugin
module.exports = {"approvalForm":"ApprovalForm_approvalForm__30Y6y","footer":"ApprovalForm_footer__2iBO3","marginBottomResize":"ApprovalForm_marginBottomResize__1EL2Q"};